import React from 'react';
import './index.css';

/** * FinalRun Component: 
 * This component handles the 'Read-Only' state display once a variance run is finished.
 * It removes the redundant summary headers that were overlapping with the main table.
 **/
const FinalRun = ({ orders }) => {
  // We identify the latest order to ensure we are referencing the correct run status
  const latestOrder = orders[orders.length - 1];

  return (
    <div className="final-run-container">
      {/* REMOVED: The redundant summary table headers that were 
          clashing with the main table display.
      */}

      <p className="final-run-disclaimer">
        This run has been finalized and is now read-only.
      </p>

      <div className="final-run-actions">
        <span className="final-run-order-label">
          Order Run #{orders.length}
        </span>
        <button 
          className="link-button final-run-print" 
          onClick={() => window.print()}
        >
          Print Variance Report
        </button>
      </div>
    </div>
  );
};

export default FinalRun;